module.exports = __webpack_public_path__ + "static/media/anc10ru.140477e3.pdf";